import { environment } from './../../../environments/environment';
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiLocauxService } from '../services/api-locaux.service';


@Component({
  selector: 'app-listing-locaux',
  templateUrl: './listing-locaux.component.html',
  styleUrls: ['./listing-locaux.component.css']
})
export class ListingLocauxComponent implements OnInit {
  criteres;
  @Input() results;
  paged : number = 1;
  loading = false;  
  @Input() total = 0;

  base_url;
  base_url_image_locaux;

  url="/locaux/listing";

  constructor(private _activatedRouter : ActivatedRoute, private _apiService : ApiLocauxService, private _router : Router) {
    this.base_url = environment.base_url;
    this.base_url_image_locaux = environment.base_url_image_locaux;
  }

  ngOnInit() {
    console.log('- INIT LISTING -', this.results);
  }

  selectLocal(id) {
    this._router.navigate(['/local/'+id+'']);
  }

  onClickMoreResults() {
    console.log('more');
    this.paged++;
    this.loading = true;

    this._apiService.getLocauxByFilter(this.paged).then(results => {
      if (results) {
        this.results = this.results.concat(results.results);
        this.loading =false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/locaux/listing-locaux/listing-locaux.component.ts